import React from 'react'
import {Row, Col, Form} from 'react-bootstrap'
import {FormattedMessage, useIntl} from 'react-intl'
import {TFormSignature} from '../../signatureFormsTypes'
import {FormikErrors, FormikTouched} from 'formik'

interface SignatureFormSettingsProps {
  values: TFormSignature
  errors: FormikErrors<TFormSignature>
  touched: FormikTouched<TFormSignature>
  handleChange: (field: string, value: string) => void
  handleBlur: (field: string) => void
}

export const SignatureFormSettings: React.FC<SignatureFormSettingsProps> = ({
  values,
  errors,
  handleChange,
  handleBlur,
}) => {
  const intl = useIntl()

  return (
    <div className='form-settings'>
      <Row>
        <Col sm={12}>
          <div className='kt-heading kt-heading--md custom-border-brand'>
            <FormattedMessage
              id='documents.signatureForms.settings.heading'
              defaultMessage='Signature form settings'
            />
          </div>
        </Col>
      </Row>

      <Row>
        <Col md={6} className='mb-4'>
          <Form.Group>
            <Form.Label>
              <FormattedMessage id='common.field.name' defaultMessage='Name' /> {errors.name ? <small className='text-danger'>{errors.name}</small> : null}
            </Form.Label>
            <Form.Control
              value={values.name}
              onChange={(e) => handleChange('name', e.target.value)}
              onBlur={() => handleBlur('name')}
              required
            />
          </Form.Group>
        </Col>

        <Col md={3} className='mb-5'>
          <Form.Group>
            <Form.Label>
              <FormattedMessage id='common.field.status' defaultMessage='Status' />
            </Form.Label>
            <Form.Select
              value={values.status}
              onChange={(e) => handleChange('status', e.target.value)}
            >
              <option value=''>
                {intl.formatMessage({
                  id: 'common.placeholder.selectOption',
                  defaultMessage: 'Select an option',
                })}
              </option>
              <option value='ACTIVE'>
                {intl.formatMessage({
                  id: 'common.status.active',
                  defaultMessage: 'Active',
                })}
              </option>
              <option value='INACTIVE'>
                {intl.formatMessage({
                  id: 'common.status.inactive',
                  defaultMessage: 'Inactive',
                })}
              </option>
            </Form.Select>
          </Form.Group>
        </Col>

        <Col md={3} className='mb-5'>
          <Form.Group>
            <Form.Label>
              <FormattedMessage
                id='documents.signatureForms.settings.language'
                defaultMessage='Language'
              />
            </Form.Label>
            <Form.Select
              value={values.language}
              onChange={(e) => handleChange('language', e.target.value)}
            >
              <option value='es'>
                {intl.formatMessage({id: 'common.language.spanish', defaultMessage: 'Spanish'})}
              </option>
              <option value='en'>
                {intl.formatMessage({id: 'common.language.english', defaultMessage: 'English'})}
              </option>
            </Form.Select>
          </Form.Group>
        </Col>

        <Col sm={12}>
          <Form.Group>
            <Form.Label>
              <FormattedMessage
                id='common.field.description'
                defaultMessage='Description'
              />
            </Form.Label>
            <Form.Control
              value={values.descripcion}
              onChange={(e) => handleChange('descripcion', e.target.value)}
              onBlur={() => handleBlur('descripcion')}
              required
            />
          </Form.Group>
        </Col>
      </Row>
    </div>
  )
}
